import { render, staticRenderFns } from "./CurrentPageComponents.vue?vue&type=template&id=4b9da39c&scoped=true&"
import script from "./CurrentPageComponents.vue?vue&type=script&lang=js&"
export * from "./CurrentPageComponents.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPageComponents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CurrentPageComponents.vue?vue&type=style&index=1&id=4b9da39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9da39c",
  null
  
)

export default component.exports